// Pôle « Contrôle » de la DGH (interface) : inscription. Il regroupe les écrans des modules G2, G3 et G5 ; les
// fichiers centraux (routeur, pages, navigation) reçoivent une ligne à l'intégration.

import { createElement } from 'react';
import { PoleControle } from './Controle';

export const inscription = {
  code: 'controle',
  routes: [{ chemin: '/controle', element: createElement(PoleControle) }],
} as const;
